import { Checkbox, Dialog } from '@recruit-robin/robin-theme/web-components';
import { useLocalStorage } from 'hooks/shared/useLocalStorage';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { usePreventScroll } from 'shared/legacy/hooks/usePreventScroll';
import { useStyles } from './ShouldInstallBrowserExtensionDialog.styles';
import { ShouldInstallBrowserExtensionDialogProps } from './ShouldInstallBrowserExtensionDialog.types';

export const IGNORE_SHOULD_INSTALL_BROWSER_EXTENSION_DIALOG = 'IGNORE_SHOULD_INSTALL_BROWSER_EXTENSION_DIALOG';

export const ShouldInstallBrowserExtensionDialog = ({
  isVisible,
  onConfirm,
}: ShouldInstallBrowserExtensionDialogProps) => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const { value, setValue } = useLocalStorage<boolean>(IGNORE_SHOULD_INSTALL_BROWSER_EXTENSION_DIALOG, false);

  usePreventScroll(isVisible);

  return (
    <Dialog
      isVisible={isVisible}
      onConfirm={onConfirm}
      title={dictionary.browserExtension}
      body={
        <div css={classes.shouldInstallBrowserExtensionBody}>
          {dictionary.shouldInstallBrowserExtensionModal}
          <img src="/install-extension.gif"></img>
          <div>
            <Checkbox label={dictionary.dontPerformThisCheckNextTime} checked={value} onClick={setValue} />
          </div>
        </div>
      }
      confirmLabel={dictionary.done}
      maxWidth={500}
    />
  );
};
